import React, { FC } from 'react';
import SentByLabDialog from 'components/orders/order-details/sent-by-lab-dialog.component';
import ExternalUserSendToClinicDialog from 'components/orders/order-details/external-user-send-to-clinic-dialog.component';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { permissions } from 'utils/permission';
import { Order } from 'models/order';

type SendToClinicDialogProps = {
    onUpdate?: (order: Order) => void;
    onClose: () => void;
    open: boolean;
    orderId?: string;
    qrCodeTechnicianId?: string;
    isUpdateCache?: boolean;
    onHandleDeliveryNoteCreation?: () => void;
};

/**
 * DD-3391: picks the send dialog the signed-in user's tier gets.
 *
 * The one place the tier is read, so the two dialogs never have to. The elevated
 * external one takes no QR technician and no cache flag: the QR station is lab
 * floor work, and the cache update belongs to the delivery schedule, which an
 * external user does not reach.
 */
const SendToClinicDialog: FC<SendToClinicDialogProps> = (props: SendToClinicDialogProps) => {
    const currentUser = currentUserVar();

    if (permissions.isElevatedExternalUser(currentUser.role)) {
        return (
            <ExternalUserSendToClinicDialog
                onUpdate={props.onUpdate}
                onClose={props.onClose}
                open={props.open}
                orderId={props.orderId}
                onHandleDeliveryNoteCreation={props.onHandleDeliveryNoteCreation}
            />
        );
    }

    return <SentByLabDialog {...props} />;
};

export default SendToClinicDialog;
